import { render, staticRenderFns } from "./SMenuListView.vue?vue&type=template&id=25b274b8&scoped=true"
import script from "./SMenuListView.vue?vue&type=script&lang=js"
export * from "./SMenuListView.vue?vue&type=script&lang=js"
import style0 from "./SMenuListView.vue?vue&type=style&index=0&id=25b274b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b274b8",
  null
  
)

export default component.exports